import { render, staticRenderFns } from "./CreateDevicesTab.vue?vue&type=template&id=5540a97c&scoped=true"
import script from "./CreateDevicesTab.vue?vue&type=script&lang=js"
export * from "./CreateDevicesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5540a97c",
  null
  
)

export default component.exports